import Logout from './Logout.vue'

export default Logout
